import {createAsyncThunk} from '@reduxjs/toolkit';
import {markAlertsRead} from "./slice";
import {alertAPI} from "../api";

export const fetchMarkAlertsRead = createAsyncThunk<void, string[]>(
    'alerts/markRead',
    async (ids, {dispatch, rejectWithValue}) => {
        if (!ids.length) return;
        try {
            await alertAPI.markRead(ids);
            dispatch(markAlertsRead(ids));
        } catch (e: unknown) {
            const msg = e instanceof Error ? e.message : JSON.stringify(e);
            return rejectWithValue(msg);
        }
    },
);
